import { RouteComponentProps } from 'react-router'
import { UsersTableStore, USERS_TABLE_STORE } from 'store'

export type UsersTablePageProps = RouteComponentProps & {
  [USERS_TABLE_STORE]?: UsersTableStore
}

// export const usersTableWidths = {
//   name: 30,
//   role: 12,
//   projects: 15,
//   addedOn: 10,
//   addedBy: 33
// }
export const usersTableWidths = {
  name: 550,
  role: 250,
  projects: 300,
  addedOn: 200,
  addedBy: 505
}
